module.exports = __webpack_public_path__ + "static/media/intro.35794468.mp3";